"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _apolloClient = require("apollo-client");

var _apolloLinkContext = require("apollo-link-context");

var _apolloLinkError = require("apollo-link-error");

var _apolloCacheInmemory = require("apollo-cache-inmemory");

var _apolloLinkBatchHttp = require("apollo-link-batch-http");

var _apolloLinkWs = require("apollo-link-ws");

var _apolloLink = require("apollo-link");

var _apolloUtilities = require("apollo-utilities");

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _credentials = require("../credentials");

var _organisations = _interopRequireDefault(require("./fragments/organisations.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var FRAGMENTS = [_organisations["default"]];
var mergedFragments = FRAGMENTS.reduce(function (merged, _ref) {
  var types = _ref.__schema.types;
  return [].concat(_toConsumableArray(merged), _toConsumableArray(types));
}, []);
var fragmentMatcher = new _apolloCacheInmemory.IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: mergedFragments
    }
  }
});
/**
 * @private
 *
 * @param {string} authToken
 * @param {string} wsEndpoint
 *
 * @return {func} apollo link fn
 */

var wsLinkBuilder = function wsLinkBuilder(authToken, wsEndpoint) {
  var link = new _apolloLinkWs.WebSocketLink({
    uri: wsEndpoint,
    options: {
      reconnect: true,
      lazy: true,
      connectionParams: {
        authToken: authToken
      }
    }
  });

  link.subscriptionClient.maxConnectTimeGenerator.duration = function () {
    return link.subscriptionClient.maxConnectTimeGenerator.max;
  };

  return link;
};
/**
 * @private
 *
 * @param {string} apiEndpoint
 *
 * @return {func} apollo link fn
 */


var getEndpointLink = function getEndpointLink(apiEndpoint) {
  return (0, _apolloLinkContext.setContext)(function (_, _ref2) {
    var module = _ref2.module;
    return {
      uri: apiEndpoint && "".concat(apiEndpoint).concat(module || '') || ''
    };
  });
};
/**
 * @private
 *
 * @param {headers} Object
 *
 * @return {Object} headers
 */


var authLink = (0, _apolloLinkContext.setContext)(function (_, _ref3) {
  var headers = _ref3.headers;

  var _getCredentials = (0, _credentials.get)(),
      token = _getCredentials.token;

  return {
    headers: _objectSpread({}, headers, {
      authorization: token ? "Bearer ".concat(token) : ''
    })
  };
});
/**
 * Clears user token if not authenticated, otherwise catch errors silently.
 *
 * @private
 *
 * @param {Object} Object
 *
 * @return {void} void 0
 */

var errorLink = (0, _apolloLinkError.onError)(function (_ref4) {
  var graphQLErrors = _ref4.graphQLErrors;

  if (!graphQLErrors || graphQLErrors.filter(Boolean).every(function (_ref5) {
    var _ref5$extensions = _ref5.extensions,
        extensions = _ref5$extensions === void 0 ? {} : _ref5$extensions;
    return extensions.code !== 'UNAUTHENTICATED';
  })) {
    return;
  }

  var credentials = (0, _credentials.get)();

  if (!credentials || !credentials.auth) {
    return;
  }

  (0, _credentials.set)(_objectSpread({}, credentials, {
    auth: false
  }));
});

var wsQueryTest = function wsQueryTest(_ref6) {
  var query = _ref6.query;

  var _getMainDefinition = (0, _apolloUtilities.getMainDefinition)(query),
      kind = _getMainDefinition.kind,
      operation = _getMainDefinition.operation;

  return kind === 'OperationDefinition' && operation === 'subscription';
};

var httpLinkBuilder = function httpLinkBuilder(apiEndpoint) {
  return authLink.concat(errorLink).concat(getEndpointLink(apiEndpoint)).concat(new _apolloLinkBatchHttp.BatchHttpLink());
};
/**
 * Get a new apollo client object
 *
 * @param {string} apiEndpoint  HTTP API endpoint
 * @param {string} wsEndpoint   WebSocket endpoint
 *
 * @return {Object}
 */


var _default = function _default(_ref7) {
  var apiEndpoint = _ref7.apiEndpoint,
      wsEndpoint = _ref7.wsEndpoint;

  var _getCredentials2 = (0, _credentials.get)(),
      auth = _getCredentials2.auth,
      token = _getCredentials2.token;

  var wsLink = wsLinkBuilder(token, wsEndpoint);
  var httpLink = httpLinkBuilder(apiEndpoint);
  return new _apolloClient.ApolloClient({
    link: !auth || (0, _lodash["default"])(token) ? httpLink : (0, _apolloLink.split)(wsQueryTest, wsLink, httpLink),
    cache: new _apolloCacheInmemory.InMemoryCache({
      fragmentMatcher: fragmentMatcher
    })
  });
};

exports["default"] = _default;